import React, {useState} from 'react';
import '../../styles/Filters/Filters.scss';
import {useSelector, useDispatch} from 'react-redux';
import {filterActive, inactive, toggleCountryFilter} from '../../redux/Filters';
import {toggleDisplaySideNav, toggleDisplayResults} from '../../redux/mobileDisplays';
import CustomButton from '../../elements/Buttons';
import useMediaQuery from '../../hooks/useMediaQuery';
import CountriesIcon from '../../assets/images/3M_countries.svg';
import MoreFiltersIcon from '../../assets/images/3M_morefilters.svg';
import TranslationLabel from '../TranslationLabel';
import LinkIcon from '../../assets/images/link-iconB.svg';
import SnapshotModal from '../../elements/SnapshotModal';

function FilterButtons() {
  const [modalShow, setModalShow] = useState(false);
  const isActive = useSelector(state => state.showFilters.isActive);
    const countryFilterCount = useSelector(state => state.showFilters.filterCount['Countries']) || 0;
    const countryFilterOpened = useSelector(state => state.showFilters.countryFilterOpened);

  const totalFilterCount =
        useSelector(state => state.showFilters.filterCount.count) - countryFilterCount;

  const isTablet = useMediaQuery('(max-width: 992px)');

  const dispatch = useDispatch();

  const countryFilter = () => {
      openFilters(true);
      console.log('here again')
      
  };

  const moreFilters = () => {
      openFilters(false);
      console.log('there again')
  };

  const openFilters = cfo => {
    dispatch(inactive());
    dispatch(filterActive(true));
      dispatch(toggleCountryFilter(cfo));
      console.log('openfilter '+ cfo)

    if (isTablet) {
      dispatch(toggleDisplaySideNav(false));
      dispatch(toggleDisplayResults(false));
    }
  };

  const handleClose = () => {
    setModalShow(false);
  };

  return (
    <>
      <div
        className={!isActive ? 'filter-buttons  d-flex flex-column mx-auto mr-0  mb-4' : 'd-none'}
      >
        <div className="text-right text-md-left text-lg-right pr-2 light-gray">
          <TranslationLabel id="label_13" />
        </div>
        <CustomButton
          className="my-1"
          onClick={countryFilter}
          src={CountriesIcon}
          alt={'icon of globe'}
          buttonLabel="label_08"
          count={countryFilterCount > 0 ? countryFilterCount : ''}
        />
        <CustomButton
          className="my-1"
          onClick={moreFilters}
          src={MoreFiltersIcon}
          alt={'icon of globe'}
          buttonLabel="label_11"
          count={totalFilterCount > 0 ? totalFilterCount : ''}
        />
        <button onClick={() => setModalShow(!modalShow)} className="data-link">
          <img src={LinkIcon} alt="Link Icon" />
          <TranslationLabel id="label_09" defaultValue="Get Data Snapshot Link" />
        </button>
      </div>
      {modalShow && (
        <div
          style={{
            zIndex: 1200,
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: '0',
            left: '0',
            backgroundColor: 'rgba(0,0,0,.75)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              borderRadius: '1px',
              color: '#4F4F4F',
              backgroundColor: '#ffffff',
              border: '4px solid #ECDCD',
            }}
          >
            <div className="modal-content">
              <div className="close-modal" onClick={handleClose}>
                X
              </div>
              <div className="modal-header">
                <h4 className="modal-title">
                  <TranslationLabel id="label_09" defaultValue="Get Data Snapshot Link" />
                </h4>
              </div>
              <div className="modal-body">
                <SnapshotModal />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FilterButtons;
